const sortByPrice = (product) => {
  product.sort(
    (a, b) =>
      parseInt(a.priceRangeV2.minVariantPrice.amount) -
      parseInt(b.priceRangeV2.minVariantPrice.amount)
  )
}

const getNonCustomisableEr = () => {
  const nonCustomisableRingSlugs = [
    "simone",
    "oprah-eternity-ring",
    "oprah-eternity-ring-03",
    "cecilia",
    "the-coco-ring",
  ]

  return nonCustomisableRingSlugs
}

const getStartingPrice = (ring, diamonds, bands) => {
  let startingPrice = 0
  const { defaultDiamond } = ring

  let filteredDiamonds = []

  const possibleShapes = defaultDiamond.map((shape) => shape.toLowerCase())

  diamonds.forEach((product) =>
    product.tags.forEach(
      (tag) =>
        possibleShapes.includes(tag.toLowerCase().trim()) &&
        filteredDiamonds.push(product)
    )
  )
  const filteredBands = []

  bands.forEach((band) => {
    const styleName = ring.baseLink?.slug || ""
    const { tags } = band
    let sorted = tags.map((tag) => tag.toLowerCase().trim())
    if (sorted.length > 0) {
      sorted.find(
        (singleTag) => singleTag.includes(styleName) && filteredBands.push(band)
      )
    }
  })

  sortByPrice(filteredBands)
  sortByPrice(filteredDiamonds)

  if (filteredBands.length > 0 && filteredDiamonds.length > 0) {
    startingPrice =
      parseInt(filteredDiamonds[0].priceRangeV2.minVariantPrice.amount) +
      parseInt(filteredBands[0].priceRangeV2.minVariantPrice.amount)
  }

  if (
    filteredBands[0] &&
    getNonCustomisableEr().includes(ring.baseLink?.slug)
  ) {
    startingPrice = parseInt(
      filteredBands[0].priceRangeV2.minVariantPrice.amount
    )
  }

  return startingPrice
}

const getOprahRingSelectedCarat = (options) => {
  let optionNames = options ? Object.keys(options) : []
  let caratName = optionNames.find(
    (optionName) => optionName.toLowerCase() === "carat"
  )
  let carat = 0

  if (caratName) {
    carat = options[caratName]
  }

  return `${carat}`
}

const getBandStyle = (tags) => {
  const styleTag = tags.find((tag) => tag.includes("style"))

  let style = "Plain"

  if (styleTag) {
    style = styleTag.includes("pave") ? "Pavé" : "Plain"
  }
  return style
}

const getBaseHandle = ({ baseLink }) => {
  const slug = baseLink ? baseLink.slug : ""
  return slug
}

module.exports = {
  getStartingPrice: getStartingPrice,
  getNonCustomisableEr: getNonCustomisableEr,
  getOprahRingSelectedCarat: getOprahRingSelectedCarat,
  getBandStyle: getBandStyle,
  getBaseHandle: getBaseHandle,
  sortByPrice: sortByPrice,
}
